import type { WordAttributeFilterKey } from '@/constants/wordAttributeFilterKeys'

export type AttributeOperator = 'has' | 'has_not' | 'eq' | 'ne' | 'contains' | 'not_contains'

export type AttributeInputType = 'boolean' | 'enum' | 'text'

export type AttributeConditionRow = {
  id: string
  field: WordAttributeFilterKey
  operator: AttributeOperator
  value: string
}

/**
 * Как показывать условие по атрибуту слова: тип поля значения и справочник.
 *
 * Подписи здесь не лежат — они в локалях (`tests.createForm.wordFilters.*`):
 * конструктор теста есть у учителя и у ученика, и обе формы обязаны говорить на
 * языке интерфейса.
 */
export const ATTRIBUTE_META: Record<
  WordAttributeFilterKey,
  { inputType: AttributeInputType; enumKey?: 'PartOfSpeech' | 'WordType' }
> = {
  transcription: { inputType: 'boolean' },
  translation: { inputType: 'boolean' },
  audio_path: { inputType: 'boolean' },
  type: { inputType: 'enum', enumKey: 'WordType' },
  part_of_speech: { inputType: 'enum', enumKey: 'PartOfSpeech' },
  example_sentence: { inputType: 'boolean' },
  synonym: { inputType: 'boolean' },
  antonym: { inputType: 'boolean' },
  note: { inputType: 'text' },
}

export const OPERATORS_BY_TYPE: Record<AttributeInputType, AttributeOperator[]> = {
  boolean: ['has', 'has_not'],
  enum: ['eq', 'ne'],
  text: ['contains', 'not_contains', 'eq', 'ne'],
}

export function defaultOperator(field: WordAttributeFilterKey): AttributeOperator {
  return OPERATORS_BY_TYPE[ATTRIBUTE_META[field].inputType][0]
}

export function newAttributeConditionRow(): AttributeConditionRow {
  return {
    id: globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    field: 'part_of_speech',
    operator: 'eq',
    value: '',
  }
}
